import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';


export default class AnalizaSiRaportareProiecte extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            proiecteAll: [],
            proiecteTop3: [],
            proiecteToDisplay: []
        }
    }

    ws = new Ws()
    u = new Utils()
    m = new Masks()
    u = new Utils()


    componentDidMount() {
        this.getData()
    }


    getData = async () => {
        let _proiecte = this.ws.customSelect('select * from proiecte where isnull(sters,0) = @p1 order by id desc', {
            p1: 0
        })

        let _taskuri = this.ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
        on (t.id_utilizator_responsabil = u.id)
        left outer join angajati a on(u.id = a.id_user)
         where t.id_etapa_proiect in 
         (select id from proiecte_etape where isnull(inactiv, 0) != 1) and isnull(t.id_task_parent, 0) = 0
          and  isnull(t.inactiv,0) !=1 order by t.cand_data asc`, {
            p1: 1
        })

        let _getBugetTask = this.ws.customSelect(`select b.*, p.id as id_proiect from bugete_taskuri b left join proiecte p
        on b.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1) where isnull(b.sters,0) != 1 `, {
            p1: 0
        })

        let _getCostTask = this.ws.customSelect(`select ct.*, p.id as id_proiect from costuri_taskuri ct left join proiecte p
        on ct.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1) where isnull(ct.sters,0 ) != 1 `, {
            p1: 0
        })


        let [proiecte, taskuri, getBugetTask, getCostTask] = await Promise.all([_proiecte, _taskuri, _getBugetTask, _getCostTask])


        if (proiecte.Succes && taskuri.Succes && getBugetTask.Succes && getCostTask.Succes) {

            console.log('proiecte :>> ', proiecte);
            console.log('taskuri :>> ', taskuri);
            console.log('getBugetTask :>> ', getBugetTask);
            console.log('getCostTask :>> ', getCostTask);

            let proiecte2 = [...proiecte.Content]

            let taskuriC = [...taskuri.Content]


            for (let i = 0, n = proiecte2.length; i < n; i++) {

                let cheltuieli = 0
                let buget = 0
                let taskuriProiect = taskuriC.filter(t => t.id_proiect === proiecte2[i].id)


                proiecte2[i]['ore'] = 0


                for (let j = 0, m = taskuriProiect.length; j < m; j++) {
                    let bugetTaskuri1 = getBugetTask.Content
                    bugetTaskuri1 = bugetTaskuri1.filter(bt => bt.id_task === taskuriProiect[j].id)

                    taskuriProiect[j]['buget'] = 0

                    for (let t = 0, n3 = bugetTaskuri1.length; t < n3; t++) {
                        taskuriProiect[j]['buget'] += bugetTaskuri1[t].valoare + (bugetTaskuri1[t].valoare * bugetTaskuri1[t].tva / 100)
                    }
                    taskuriProiect[j]['cost'] = 0

                    let costTask1 = [...getCostTask.Content].filter(cT => cT.id_task === taskuriProiect[j].id)

                    for (let cT = 0, n6 = costTask1.length; cT < n6; cT++) {

                        taskuriProiect[j]['cost'] += costTask1[cT].valoare + (costTask1[cT].valoare * costTask1[cT].tva / 100)
                    }



                    taskuriProiect[j]['profit'] = taskuriProiect[j]['buget'] - taskuriProiect[j]['cost']


                    let zileTask = this.m.jsDatesDifferenceInDays(new Date(this.u.ParseDataFromSql(taskuriProiect[j]['cand_data'])), new Date(this.u.ParseDataFromSql(taskuriProiect[j]['pana_cand_data'])))


                    taskuriProiect[j]['ore_muncite'] = zileTask * 8
                    proiecte2[i]['ore'] += taskuriProiect[j]['ore_muncite']

                    console.log('zileTask :>> ', zileTask);

                }

                let costTask = [...getCostTask.Content].filter(cT => cT.id_proiect === proiecte2[i].id)

                for (let cT = 0, n6 = costTask.length; cT < n6; cT++) {

                    cheltuieli += costTask[cT].valoare + (costTask[cT].valoare * costTask[cT].tva / 100)
                }

                let bugetTaskuri = getBugetTask.Content
                bugetTaskuri = bugetTaskuri.filter(bt => bt.id_proiect === proiecte2[i].id)



                for (let t = 0, n3 = bugetTaskuri.length; t < n3; t++) {
                    buget += bugetTaskuri[t].valoare + (bugetTaskuri[t].valoare * bugetTaskuri[t].tva / 100)
                }


                proiecte2[i]['buget'] = +(Math.round(buget + "e+3") + "e-3")

                proiecte2[i]['cost'] = +(Math.round(cheltuieli + "e+3") + "e-3")

                proiecte2[i]['profit'] = proiecte2[i]['buget'] - proiecte2[i]['cost']

                proiecte2[i]['taskuri'] = taskuriProiect
                proiecte2[i]['expand'] = false
            }


            let proiecteAll = [...proiecte2]
            proiecteAll = proiecteAll.sort((a, b) => {
                if (a.profit > b.profit) {
                    return 1
                } else {
                    return -1
                }
            })

            let top3Count = 3
            let proiecteTop3 = []

            for (let i = 0, n = proiecteAll.length > 3 ? top3Count : proiecteAll.length; i < n; i++) {

                proiecteTop3.push(proiecteAll[i])
            }

            console.log('proiecte2 :>> ', proiecte2);
            this.setState({
                proiecteAll: proiecteAll,
                proiecteTop3: proiecteTop3,
                proiecteToDisplay: proiecteTop3
            })

        }



    }

    expandProiect = (p) =>{

        let proiecte = [...this.state.proiecteToDisplay]

        let pIdx = proiecte.findIndex(pr => pr.id === p.id);

        if(pIdx !== -1){

            proiecte[pIdx]['expand'] = !proiecte[pIdx]['expand']

            this.setState({proiecteToDisplay:proiecte})
        }
    }


    afisazaToateProiectele = () =>{

        if(this.state.proiecteToDisplay.length > 3){
            this.setState({proiecteToDisplay:this.state.proiecteTop3})
        }else{
            this.setState({proiecteToDisplay:this.state.proiecteAll})
           
        }
    }

    goToProiect = (p)=>{
        this.props.history.push(`/projectdetails/${p.id}/1`)
    }


    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.analizaSiRaportareProiecte} </h5>
                        </Grid>

                        <Grid style={{ paddingTop: 20, textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <span style={{ textAlign: 'left', paddingLefft: 20, fontSize: 14 }} >{this.dictionary.financiar.top3Proiecte} </span>
                        </Grid>

                        <Grid onClick={this.afisazaToateProiectele} style={{ paddingTop: 20, textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <span style={{ textAlign: 'left', paddingLefft: 20, textDecoration: 'underline', color: '#94c3f3', fontSize: 14, cursor: 'pointer' }} >{this.dictionary.financiar.afisazaToateProiectele} </span>
                        </Grid>
                    </Grid>

                    <Divider className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>
                        {this.state.proiecteToDisplay.map((p, idx) => {

                            return (
                                <Grid style={{ marginTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid onClick={()=>{this.goToProiect(p)}} style={{cursor:'pointer'}} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.numeProiect}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400, color: 'black' }}>{p.titlu} </span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.profitabilitate}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.toFixedIfNecessary(p.profit, 2) } Lei </span>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.totalOre}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{p.ore}</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Grid style={{ textAlign: 'left' }} container>
                                                <Grid onClick={()=>{this.expandProiect(p)}} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <i style={{cursor:'pointer'}} className='material-icons'>{p.expand ? 'expand_less' : 'expand_more'}</i>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {p.expand && p.taskuri.map((t, idx2) => {
                                        return (
                                            <Grid key={idx2} style={{marginTop:20, paddingLeft:10}} container>
                                                <Grid style={{position:'relative'}} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                    <div style={{position:'absolute', width:5, height:'100%', backgroundColor:'#c4c4c4', left: -10}}>

                                                    </div>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.numeSarcina}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400, color: 'black' }}>{t.titlu} </span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.cheltuieli}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.toFixedIfNecessary(t.cost,2)} Lei </span>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.buget}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.toFixedIfNecessary(t.buget,2)} Lei</span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.profit}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.toFixedIfNecessary(t.profit,2)} Lei</span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.totalOre}</span>
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{t.ore_muncite}</span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <Grid style={{ textAlign: 'left' }} container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}></span>
                                                        </Grid>
                                                       
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                    })}

                                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                </Grid>
                            )

                        })}

                    </Grid>
                </Grid>

            </Grid>
        );
    }
}